// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 18 20"
    {...props}
  >
    <path
      stroke="#656D75"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.15833 11.2584L11.85 14.5751M11.8417 5.42508L6.15833 8.74175M16.5 4.16675C16.5 5.54746 15.3807 6.66675 14 6.66675C12.6193 6.66675 11.5 5.54746 11.5 4.16675C11.5 2.78604 12.6193 1.66675 14 1.66675C15.3807 1.66675 16.5 2.78604 16.5 4.16675ZM6.5 10.0001C6.5 11.3808 5.38071 12.5001 4 12.5001C2.61929 12.5001 1.5 11.3808 1.5 10.0001C1.5 8.61937 2.61929 7.50008 4 7.50008C5.38071 7.50008 6.5 8.61937 6.5 10.0001ZM16.5 15.8334C16.5 17.2141 15.3807 18.3334 14 18.3334C12.6193 18.3334 11.5 17.2141 11.5 15.8334C11.5 14.4527 12.6193 13.3334 14 13.3334C15.3807 13.3334 16.5 14.4527 16.5 15.8334Z"
    />
  </svg>
);
const IconShare = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconShare;
